
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 134.125 109.083","fill":"#fff","fill-rule":"evenodd","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round"}, attrs),
              ...rest,
            },
            children.concat([_c('use',{attrs:{"xlink:href":"#display","x":"1.042","y":"1.042"}}),_c('symbol',{attrs:{"id":"display","overflow":"visible"}},[_c('g',{attrs:{"stroke":"none","fill-rule":"nonzero"}},[_c('path',{attrs:{"d":"M1.59 0L0 83.881h129.527l.681-83.333L1.59 0z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M9.375 8.881h112.5v54.167H9.375z","fill":"#FFF"}}),_c('path',{attrs:{"d":"M121.875 63.048V8.881l-30.571-.675 18.542 54.292z"}}),_c('path',{attrs:{"d":"M62.025 94.211l-.417 12.279 9.467.221.406-13.938s-1.777-2.708-.625-2.708h-8.333c1.152 0-.475 4.167-.475 4.167z","fill":"currentColor"}})]),_c('g',{attrs:{"stroke-width":"4.167"}},[_c('path',{attrs:{"d":"M1.042.548h129.167v83.333H1.042z","fill":"none"}}),_c('path',{attrs:{"d":"M96.715 106.49H36.619","fill-rule":"nonzero","fill":"#000"}})]),_c('path',{attrs:{"d":"M62.5 73.465a4.16 4.16 0 118.333 0 4.16 4.16 0 11-8.333 0z","stroke":"none","fill":"#FFF","fill-rule":"nonzero"}}),_c('path',{attrs:{"d":"M9.375 8.881h112.5v54.167H9.375zm61.458 83.267v13.304M62.5 92.148v13.304","fill":"none","stroke-width":"4.167"}})])])
          )
        }
      }
    